import React from 'react';
import './style.scss';

const TicketPhotos = ({ photos, setPhotoComponent, setSelectedPhoto }) => {
  return (
    <div className={'photolist-container'}>
      <div className="photos">
        {photos.map(photo => {
          return (
            <div key={photo.original} className="photo-container">
              <img
                src={photo.thumbnail_download_url}
                data-src={photo.thumbnail_download_url}
                className="s3-image"
                alt="Ticket"
                // onError={onErrorHandler}
                onClick={() => {
                  setSelectedPhoto(photo.original_download_url);
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="buttons-container">
        <button type="submit" className="cancel-button" onClick={() => setPhotoComponent(false)}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TicketPhotos;
